<template>
  <v-container fluid class="ma-0 py-4 transparent">
    <v-row v-if="isLoading">
      <v-col>
        <v-skeleton-loader type="card" class="mx-auto" max-width="90%"/>
      </v-col>
    </v-row>

		<v-row v-if="!isLoading && (isFormStored || isFormSubmitted) && !unavailable">
      <v-col>
				<div class="d-flex align-center">
					<p v-if="isFormStored" class="mb-0" style="font-weight: 500;">{{ $t('app.common.stored_date') }}</p>
					<p v-if="submitted" class="mb-0" style="font-weight: 500;">{{ $t('app.common.submitted_date') }}</p>
					<p v-if="isFormStored || submitted" class="ml-4 mb-0">{{ this.formatLongDateTime(formSubmissionStatusDate) }}</p>
				</div>
      </v-col>
    </v-row>

		<v-row v-if="!isLoading && (submitted || unavailable)">
      <v-col>
        <v-card v-if="submitted || unavailable" outlined :class="$vuetify.breakpoint.xs ? 'card-mobile' : ''">
          <v-card-text>
              <v-row no-glutters>
                <v-col v-if="submitted && !unavailable" cols="12" class="d-flex justify-center align-center">
                  <v-icon color="green" class="mr-3" x-large>
                    mdi-checkbox-marked-circle
                  </v-icon>
                  <h2>{{ $t('app.common.form-submitted') }}</h2>
                </v-col>
                <v-col v-if="!submitted && unavailable" cols="12" class="d-flex justify-center align-center">
                  <v-icon color="orange" class="mr-3" x-large>
                    mdi-alert
                  </v-icon>
                  <h2>{{ $t('app.common.form-unavailable') }}</h2>
                </v-col>
                <v-col v-if="submitted && !unavailable" cols="12" class="d-flex justify-center align-center">
                  <v-btn depressed raised rounded
                  class="download"
                  @click="print()">
                    <v-icon class="mr-2">mdi-printer-outline</v-icon>
                    {{ $t('app.common.print') }}
                  </v-btn>
                </v-col>
              </v-row>

          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-container fluid v-if="!isLoading && !unavailable">
      <v-row class="mt-4">
        <v-col>
          <h3 color="#000000" class="text-truncate">{{ formSubmissionName }}</h3>
        </v-col>
      </v-row>
      <v-card outlined :class="$vuetify.breakpoint.xs ? 'card-mobile' : ''">
        <v-row no-glutters>
					<v-col cols="12">  
						<iframe ref="viewer" style="min-width:100%; border:0;" :src="'form-viewer.html?callbackId='+callbackId" />
					</v-col>
				</v-row>
      </v-card>
    </v-container>
			
		<ConfirmDialog ref="dlgConfirm"
			:title="$t('app.common.confirm-dialog.title')"
			:message="$t('app.common.confirm-dialog.text')"
			:titleOk="$t('app.common.dialog-buttons.ok')"
			:titleCancel="$t('app.common.dialog-buttons.cancel')"
			@confirmed="submitFormSubmissionData($event)" />

    <!-- INICIO BLOQUE MENSAJE ESTADO PETICIONES -->
    <v-snackbar
      v-model="showAlert"
      :timeout="alertTimeout"
      :color="alertColor">
        {{alertText}}
        <v-btn text @click="showAlert=false">
          {{ $t('app.common.dialog-buttons.close') }}
        </v-btn>
    </v-snackbar>
    <!-- FIN BLOQUE ESTADO PETICIONES -->

  </v-container>
</template>

<script>
import BaseModule from '@/components/common/BaseModule.js';
import ConfirmDialog from '@/components/common/ConfirmDialog.vue';
import api from '@/api/fundattio.js';
import { v4 as uuidv4 } from 'uuid';
import formioUtils from 'formiojs/utils';

export default {
    name: 'FormularioMain',
    mixins: [BaseModule],
    components: {
			ConfirmDialog
    },
    data () {
    return {
      isLoading: false,
			callbackId: `formio-viewer-${uuidv4().toString()}`,
      currentMode: 'cliente',
      submitted: false,
      unavailable: false,
      showAlert: false,
      alertColor: 'red',
      alertText: '',
      alertTimeout: 6000,
    }
  },
  computed: {
    formSubmissionInfo() {
      return this.$store.state.fundattio.formSubmissionInfo;
    },
    form() {
			if (!this.$store.state.fundattio.formSubmissionInfo) {
				return null;
			}
      return this.$store.state.fundattio.formSubmissionInfo.form;
    },
    formSubmission() {
			if (!this.$store.state.fundattio.formSubmissionInfo) {
				return null;
			}
      return this.$store.state.fundattio.formSubmissionInfo.formSubmission;
    },
    formSubmissionName() {
			if (!this.$store.state.fundattio.formSubmissionInfo) {
				return '';
			}
      return this.$store.state.fundattio.formSubmissionInfo.formSubmission.name;
    },
    formSubmissionStatusDate() {
			if (!this.$store.state.fundattio.formSubmissionInfo) {
				return '';
			}
      return this.$store.state.fundattio.formSubmissionInfo.formSubmission.statusDate;
    },
    isFormStored() {
			if (!this.$store.state.fundattio.formSubmissionInfo) {
				return false;
			}
      return this.$store.state.fundattio.formSubmissionInfo.formSubmission.status === this.constants.STORED_STATUS;
    },
    isFormSubmitted() {
			if (!this.$store.state.fundattio.formSubmissionInfo) {
				return false;
			}
      return this.$store.state.fundattio.formSubmissionInfo.formSubmission.status >= 2;
    },
  },
	mounted()  {
		if (window.addEventListener) {
			window.addEventListener("message", this.processMessage, false);
		} else {
			window.attachEvent("onmessage", this.processMessage);
		}      
  },
  methods: {
    doShowAlert(payload) {
      this.alertColor = payload.color;
      this.alertText = payload.text;
      this.showAlert = true;
    },
    getFormSubmissionInfoByToken(token) {
      this.submitted = false;
      this.unavailable = false;

			this.isLoading = true;

      api.getFormSubmissionInfoByToken(token,
        res => {
          this.isLoading = false;
          this.$store.commit('fundattio/setFormSubmissionInfo', res);
					console.log(`*** formSubmissionInfo: ${JSON.stringify(this.formSubmissionInfo)}`);

          // Si el formulario no existe, está fuera de fecha o ya se ha enviado, no continuamos
          if (!this.form ||!this.formSubmission || this.isFormSubmitted) {
            this.unavailable = true;
            return;
          }

					this.$nextTick(() => {
						this.sendFormData();
					});
        },
        () => {
          this.isLoading = false;
          this.doShowAlert({ text: this.$t('app.get-form-submission.error-message'), color: 'red' });
        }
      );
    },		
		shouldDisableComponent(field) {
			if (!!field.tags && field.tags.length > 0) { 
				return !field.tags.includes(this.currentMode);
			}

			if (!!field.properties && !!field.properties["tags"]) { 
				return field.properties["tags"].indexOf(this.currentMode) < 0;
			}

			return false;
		},
		shouldRequireComponent(field) {
			if (field.validate && field.validate.required) {
				return true;
			}

			if (!!field.tags && field.tags.length > 0) {
				return field.tags.includes(this.currentMode);
			}

			if (!!field.properties && !!field.properties["tags"]) {
				return field.properties["tags"].indexOf(this.currentMode) >= 0;
			}

			return false;
		},
		handleDatagrids(form) {
			form.components.forEach(component => {
				if (component.type === 'datagrid') {
					if (component.properties && component.properties['enableAddingRemovingRows']) {
						component.disableAddingRemovingRows = !component.properties['enableAddingRemovingRows'].includes(this.currentMode);
					}
				} 
			});
		},
		disableComponents(form) {
			formioUtils.eachComponent(form.components, (component) => {
				component.disabled = this.shouldDisableComponent(component);

				if (!component.validate) {
					component.validate = {};
				}
						
				component.validate.required = this.shouldRequireComponent(component);
			});
		},
		print() {							
			this.$refs.viewer.contentWindow.postMessage({  
				action: 'print', 
				payload: '{}',
			});			
		},
		sendFormData() {
			const definition = JSON.parse(this.form.definition);

			this.disableComponents(definition);
      this.handleDatagrids(definition);
			
			this.$store.commit('fundattio/updateFormDefinition', JSON.stringify(definition));

			this.$refs.viewer.contentWindow.postMessage({  
				definition: this.form ? this.form.definition : '{}', 
				lastSubmission: this.formSubmission ? this.formSubmission.submissionData : '{}', 
				role: null,
				protected: this.submitted ? 'true' : 'false',
				sessionInfo: '{}',
			});
		},
		storeFormSubmissionData(payload) {
			const data = {
				id: this.formSubmission.id,
        formId: this.form.id,
				field1: this.extractField1(payload),
				field2: this.extractField2(payload),
				field3: this.extractField3(payload),
				field4: this.extractField4(payload),
        submissionData: JSON.stringify(payload),
				progress: this.calculateProgress(payload),
				uploadsProgress: this.calculateUploadsProgress(payload)
			};

			this.isLoading = true;

			api.storeFormSubmissionData(this.formSubmission.id, data,
				res => {
				this.isLoading = false;

					if (!res) {
						this.doShowAlert({ text: this.$t('app.common.form-store-failed'), color: 'red' });
						return;
					}

          this.$store.commit('fundattio/setFormSubmission', res);
          console.log(`*** formSubmission: ${JSON.stringify(this.formSubmission)}`);

					this.$nextTick(() => {
						this.getFormSubmissionInfoByToken(res.token);
					});

					this.doShowAlert({ text: this.$t('app.common.form-stored'), color: 'green' });
				},
				error => {
					this.isLoading = false;
					this.doShowAlert({ text: error, color: 'red' });
				}
			);
    },
		submitFormSubmissionData(payload) {
			const data = {
				id: this.formSubmission.id,
        formId: this.form.id,
				field1: this.extractField1(payload),
				field2: this.extractField2(payload),
				field3: this.extractField3(payload),
				field4: this.extractField4(payload),
        submissionData: JSON.stringify(payload),
				progress: this.calculateProgress(payload),
				uploadsProgress: this.calculateUploadsProgress(payload)
			};

			this.isLoading = true;

			api.submitFormSubmissionData(this.formSubmission.id, data,
				res => {
					this.isLoading = false;

					if (!res) {						
						this.doShowAlert({ text: this.$t('app.common.form-submit-failed'), color: 'red' });
						return;
					}

          this.$store.commit('fundattio/setFormSubmission', res);
          console.log(`*** formSubmission: ${JSON.stringify(this.formSubmission)}`);

					this.submitted = true;
					/*this.$nextTick(() => {
						this.getFormSubmissionInfoByToken(res.token);
					});*/

					this.doShowAlert({ text: this.$t('app.common.form-submitted'), color: 'green' });
				},
				error => {
					this.loading = false;
					this.doShowAlert({ text: error, color: 'red' });
				}
			);
    },
		extractField1(submission) {
			return this.extractField(submission, 1);
		},
		extractField2(submission) {
			return this.extractField(submission, 2);
		},
		extractField3(submission) {
			return this.extractField(submission, 3);
		},
		extractField4(submission) {
			return this.extractField(submission, 4);
		},
		extractField(submission, fieldValue) {
			const definition = JSON.parse(this.form.definition);
			
			const components = formioUtils.searchComponents(definition.components, {
				showInTable: fieldValue
			});

			if (components.length === 0) {
				return null;
			}

			const value = formioUtils.getValue(submission, components[0].key);

			const strValue = String(value);

			if (strValue === 'null' || strValue === 'undefined' || strValue.indexOf('[object') === 0 || strValue.trim().length === 0) {
				return null;
			}

			return strValue;
		},
    calculateProgress(submission) {
			let numQuestions = 0;
			let numAnswered = 0;

			const definition = JSON.parse(this.form.definition);
			
			formioUtils.eachComponent(definition.components, (component) => {
				if (component.type !== 'file' && component.showInProgress) {
					numQuestions++;
					
					const value = formioUtils.getValue(submission, component.key);

					const strValue = String(value);

					if (strValue !== 'null' && strValue !== 'undefined' && strValue.trim().length > 0) {
						numAnswered++;
					}
				}
			});

            if (numQuestions === 0) {
                return 0.0;
            } 

			return numAnswered / numQuestions;
		},		
    calculateUploadsProgress(submission) {
			let numQuestions = 0;
			let numAnswered = 0;

			const definition = JSON.parse(this.form.definition);
			
			const components = formioUtils.searchComponents(definition.components, {
				type: 'file'
			});
			
			formioUtils.eachComponent(components, (component) => {
				numQuestions++;

				const value = formioUtils.getValue(submission, component.key);

				const strValue = String(value);

				if (strValue !== 'null' && strValue !== 'undefined' && strValue.trim().length > 0) {
					numAnswered++;
				}
			});

            if (numQuestions === 0) {
                return 0.0;
            }             

			return numAnswered / numQuestions;
		},
		processMessage(msg) {
			if (!msg.data) {
				return;
			}

			if (!msg.data.target || msg.data.target !== this.callbackId) {
				return;
			}

			if (msg.data.type === 'ready') {
				this.sendFormData();
				return;
			}

			if (msg.data.type === 'fix-height') {
				this.$refs.viewer.style.height = `${msg.data.payload}px`;
				this.$refs.viewer.scrollTop = 0;
				return;
			}

			if (msg.data.type === 'store') {
				this.storeFormSubmissionData(msg.data.payload);
				return;
			}

      if (msg.data.type === 'submit') {
				this.$refs.dlgConfirm.confirm(msg.data.payload);
				//this.submitFormSubmissionData(msg.data.payload);
				return;
			}
		}
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      this.submitted = false;
      this.unavailable = false;
      this.$store.commit('fundattio/setFormSubmissionInfo', null);
      this.getFormSubmissionInfoByToken(to.params.token);
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.submitted = false;
      vm.unavailable = false;
      vm.$store.commit('fundattio/setFormSubmissionInfo', null);
      vm.getFormSubmissionInfoByToken(to.params.token);
    })
  }
}
</script>

<style scoped>
h3 {
  color: #000000 !important;
}
.v-card {
  padding: 20px;
  border-radius: 10px !important;
  border: 1px solid #e0e0e0 !important;
}
.card-mobile {
  padding: 0;
  border-radius: 0 !important;
  border: 0 !important;
}
iframe {
  /*border: 1px solid #e0e0e0 !important;*/
  background-color: #3d3d3d !important;
}
#signature {
  border: 3px solid #2361aa;
  border-radius: 5px;
  background-color: white !important;
  cursor: crosshair !important;
}
#signature.padDisabledCss {
  cursor: not-allowed !important;
}
.container {
  width: "100%";
  padding: 8px 16px;
}
.download.v-btn {
  color: white !important;
  background-color: #000000 !important;
  font-size: 0.8rem !important;
  letter-spacing: normal !important;
}
</style>